export default {
  'settings.title': 'सेटिंग्स',
  'settings.subtitle': 'अपने संगठन, संचालन, लोगों और खाते का प्रबंधन करें।',
  'settings.subtitleLong': 'अपने संगठन, संचालन, लोगों और खाते का प्रबंधन करें — सब एक जगह।',
  'settings.workspace': 'वर्कस्पेस',
  'settings.groupOrganization': 'संगठन',
  'settings.groupOperations': 'संचालन',
  'settings.groupPeople': 'लोग',
  'settings.groupAccount': 'खाता',
  'settings.company': 'कंपनी',
  'settings.companyDesc': 'प्रत्येक रिपोर्ट और PDF पर ब्रांडिंग',
  'settings.ledgers': 'लेजर',
  'settings.ledgersDesc': 'प्रति शाखा पुस्तकें',
  'settings.line': 'सेवा लाइनें',
  'settings.lineDesc': 'जहाँ से आप संचालन करते हैं',
  'settings.banks': 'बैंक',
  'settings.banksDesc': 'ऑनलाइन भुगतान और ऑडिट के लिए कंपनी बैंक खाते',
  'settings.finance': 'वित्त डिफ़ॉल्ट',
  'settings.financeDesc': 'वित्त के लिए ब्याज % और OP ब्याज',
  'settings.financialYear': 'वित्तीय वर्ष',
  'settings.financialYearDesc': 'रिपोर्ट और डैशबोर्ड के लिए वर्ष',
  'settings.sms': 'SMS अनुस्मारक',
  'settings.smsDesc': 'भुगतान अनुस्मारक दिन और SMS उपयोग',
  'settings.payment': 'भुगतान',
  'settings.paymentDesc': 'निपटान प्राथमिकताएँ',
  'settings.owners': 'मालिक',
  'settings.ownersDesc': 'कैप टेबल और संपर्क',
  'settings.admins': 'वर्कस्पेस व्यवस्थापक',
  'settings.adminsDesc': 'डेस्क भूमिकाएँ और जवाबदेही',
  'settings.subscription': 'सदस्यता',
  'settings.subscriptionDesc': 'योजना, बिलिंग और नवीनीकरण',
  'settings.profile': 'प्रोफ़ाइल',
  'settings.profileDesc': 'पहचान और साइन-इन सुरक्षा',
  'settings.language': 'भाषा',
  'settings.languageDesc': 'वेबसाइट प्रदर्शन भाषा',
  'settings.languageTitle': 'प्रदर्शन भाषा',
  'settings.languageHint': 'चुनें कि वर्कस्पेस में मेनू, लेबल और बटन कैसे दिखें।',
  'settings.languageSaved': 'इस डिवाइस के लिए भाषा अपडेट की गई।',

  'settings.font': 'फ़ॉन्ट आकार',
  'settings.fontDesc': 'फ़ोन और डेस्कटॉप पर टेक्स्ट का आकार',
  'settings.fontTitle': 'प्रदर्शन फ़ॉन्ट आकार',
  'settings.fontHint': 'चुनें कि मेनू, लेबल और राशि कितनी बड़ी दिखें। हिंदी और तेलुगु में मोबाइल पर पढ़ने में आसानी के लिए अतिरिक्त बढ़ोतरी मिलती है।',
  'settings.fontSaved': 'इस डिवाइस के लिए फ़ॉन्ट आकार अपडेट किया गया।',
  'settings.fontPreviewLine': 'नमूना पाठ — मेनू, लेबल और EMI राशि एक साथ बदलती है।',
  'font.compact': 'संक्षिप्त',
  'font.comfortable': 'आरामदायक',
  'font.large': 'बड़ा',
  'font.extraLarge': 'अतिरिक्त बड़ा',
  'font.maximum': 'अधिकतम',

  'settings.theme': 'रंग थीम',
  'settings.themeDesc': 'वर्कस्पेस में एक्सेंट रंग',
  'settings.themeTitle': 'वर्कस्पेस रंग थीम',
  'settings.themeHint': 'एक एक्सेंट रंग चुनें — बटन, नेविगेशन, हाइलाइट और चार्ट पूरी वेबसाइट में बदल जाते हैं।',
  'settings.themeSaved': 'इस डिवाइस के लिए रंग थीम अपडेट की गई।',
  'settings.themePreview': 'लाइव पूर्वावलोकन',
  'settings.themeActiveBadge': 'सक्रिय',
  'theme.emerald': 'पन्ना (Emerald)',
  'theme.blue': 'नीला',
  'theme.violet': 'बैंगनी',
  'theme.rose': 'गुलाबी',
  'theme.amber': 'अंबर',
  'theme.indigo': 'इंडिगो',
  'theme.teal': 'टील',
  'theme.orange': 'नारंगी',

  'settings.fontFineTune': 'स्लाइडर से ठीक करें',
  'settings.fontCurrent': 'वर्तमान: {{percent}}',
  'settings.fontLivePreview': 'लाइव पूर्वावलोकन',
  'settings.fontReset': 'डिफ़ॉल्ट पर रीसेट',
  'settings.fontSavedAt': '{{percent}} पर सहेजा गया',

  'settingsForm.companyIdentity': 'कंपनी पहचान',
  'settingsForm.legalName': 'कानूनी कंपनी नाम',
  'settingsForm.displayName': 'प्रदर्शन / व्यापार नाम',
  'settingsForm.tagline': 'टैगलाइन',
  'settingsForm.logo': 'लोगो URL',
  'settingsForm.contact': 'संपर्क',
  'settingsForm.phone': 'प्राथमिक फ़ोन',
  'settingsForm.altPhone': 'वैकल्पिक फ़ोन',
  'settingsForm.email': 'ईमेल',
  'settingsForm.website': 'वेबसाइट',
  'settingsForm.addressLine1': 'पता पंक्ति 1',
  'settingsForm.addressLine2': 'पता पंक्ति 2 (वैकल्पिक)',
  'settingsForm.city': 'शहर',
  'settingsForm.state': 'राज्य',
  'settingsForm.pincode': 'पिनकोड',
  'settingsForm.country': 'देश',
  'settingsForm.registration': 'पंजीकरण',
  'settingsForm.gstin': 'GSTIN',
  'settingsForm.pan': 'PAN',
  'settingsForm.partners': 'साझेदार / निदेशक',
  'settingsForm.saveCompany': 'कंपनी प्रोफ़ाइल सहेजें',
  'settingsForm.ledgerTitle': 'प्रति शाखा एक पुस्तक',
  'settingsForm.ledgerHint': 'प्रत्येक लेजर को अपना डेस्क लॉगिन और अलग रिकॉर्ड मिलते हैं।',
  'settingsForm.ledgerName': 'लेजर नाम',
  'settingsForm.deskLogin': 'डेस्क लॉगिन ईमेल',
  'settingsForm.createLedger': 'लेजर बनाएँ',
  'settingsForm.serviceLines': 'सेवा लाइनें',
  'settingsForm.addLine': 'लाइन जोड़ें',
  'settingsForm.banksList': 'कंपनी बैंक खाते',
  'settingsForm.addBank': 'बैंक खाता जोड़ें',
  'settingsForm.bankName': 'बैंक का नाम',
  'settingsForm.accountName': 'खाता नाम',
  'settingsForm.accountNumber': 'खाता संख्या',
  'settingsForm.branch': 'शाखा',
  'settingsForm.ifsc': 'IFSC',
  'settingsForm.confirmDeleteBank': 'यह बैंक खाता हटाएँ?',
  'settingsForm.noBanksYet': 'अभी कोई बैंक खाता नहीं। ऑनलाइन ट्रैकिंग के लिए एक जोड़ें।',
  'settingsForm.defaultInterest': 'डिफ़ॉल्ट ब्याज %',
  'settingsForm.opInterest': 'OP ब्याज %',
  'settingsForm.overduePenalty': 'अतिदेय जुर्माना',
  'settingsForm.reminderDays': 'देय से पहले अनुस्मारक दिन',
  'settingsForm.saveReminders': 'अनुस्मारक सेटिंग्स सहेजें',
  'settingsForm.subscriptionPlan': 'वर्तमान योजना',
  'settingsForm.changePassword': 'पासवर्ड बदलें',
  'settingsForm.currentPassword': 'वर्तमान पासवर्ड',
  'settingsForm.newPassword': 'नया पासवर्ड',
  'settingsForm.confirmPassword': 'पासवर्ड की पुष्टि करें',
  'settingsForm.addAdmin': 'व्यवस्थापक जोड़ें',
  'settingsForm.role': 'भूमिका',
  'settingsForm.permissions': 'अनुमतियाँ',
  'settingsForm.addOwner': 'मालिक जोड़ें',
  'settingsForm.shareholding': 'हिस्सेदारी %',
} as const;
